import React from 'react';
import './RecommendedVideos.css';
import Videocard from './Videocard';

function RecommendVideos() {
    return (
        <div className="recommendedvideos">
            <h2>Recommended</h2>
            <div class="recommendedvideos__vids" >
                <Videocard
                    title="Become a web developer in 1 week"
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
                <Videocard
                    title="Become a web developer in 1 week"
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/GePLvNgWROg/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDEI9EKAPsCrGpjbTtsD4P1jH4tAw"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
                <Videocard
                    title="Why to a software developer?"
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/XWeYYXgu5rQ/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBmu3w6pndtSzFGtsTXaRA9IjuT6g"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
                <Videocard
                    title="Building my first html/css Project"
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/yxQDVebjgqM/hq720.jpg?sqp=-oaymwEZCNAFEJQDSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBeSLOo51pC0AD51FxB_wIez2E6xg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
                <Videocard
                    title="Top Programming languages in 2020"
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/Jx9b6cgV2JI/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCH5TY_9DzGpmcsF05MxWkjlEGQrg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />

                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />

                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />


                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />

                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />

                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />

                <Videocard
                    title="Personal Branding "
                    views="2.3M Views"
                    timestamp="3 days ago"
                    image="https://i.ytimg.com/vi/HxDqyK3fNUs/hqdefault.jpg?sqp=-oaymwEZCPYBEIoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBt2Ono_XRo32fhhPVEZZSsKzLLpg"
                    channel="Sambulo Senda"
                    channelImage="https://i.ytimg.com/an_webp/NN1oN0-1M4A/mqdefault_6s.webp?du=3000&sqp=CIDUivkF&rs=AOn4CLCI3upm7_La1Bkp4izuPqR1Db-PKA"
                />
            </div>
        </div>
    )
}
export default RecommendVideos
